import { useState } from "react"
import useSendEmail from '../../hooks/useSendEmail'
import { useTranslation } from 'react-i18next';

const ContactForm = () => {
    const { t } = useTranslation();

    const contactForm = t('contact-form');
    const [email, setEmail] = useState('')
    const [message, setMessage] = useState('')
    const [name, setName] = useState('')
    const [isDisabled, setIsDisabled] = useState(false);
    const [sendEmail] = useSendEmail();


    const onSubmit = () => {
        if (email === '' || message === '' || name === '') {
            return console.log('Please fill all the fields');
        }
        console.log('Data', { email, message, name })
        setIsDisabled(true);
        sendEmail(setIsDisabled, { email, message, name });

        setEmail('');
        setMessage('');
        setName('');
    }
    return (
        <div className='d-flex px-3 px-0'>
            <div className='contact-form-card mx-auto my-5 px-3 px-md-5 pt-5 pb-4'>
                <input
                    type='text'
                    className='bg-color input-field input-height ps-3'
                    placeholder={contactForm.name}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
                <input
                    type='email'
                    className='bg-color input-field input-height ps-3'
                    placeholder={contactForm.email}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <textarea
                    className='bg-color input-field textarea-height ps-3'
                    placeholder={contactForm.message}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                />
                <div className='d-flex mt-1'>
                    <button
                        type='button'
                        onClick={() => onSubmit()}
                        className={`rounded-pill px-4 text-white fs-15 mx-auto ${!isDisabled ? 'contact-button' : 'disabled-button'}`}
                        style={{ height: '46.58px', width: '120.6px' }}
                    >
                        {contactForm.button}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ContactForm;